import DoubleBar from '../DoubleBar/DoubleBar'
import {
  getMatchStatMap,
  getPossessionData,
  matchStatFieldNames
} from '../../utils/DataUtils'
import { snakeToPascal } from '../../utils/StringUtils'
import DataMissing from '../DataMissing/DataMissing'
import './MatchDetailsContainer.css'

const MatchDetailsContainer = ({ match, homeTeam, awayTeam }) => {
  const possessionInfo = getPossessionData(match)
  const matchStats = getMatchStatMap(match)
  const homeTeamMatchdata = matchStats.get(homeTeam.team_id) || {}
  const awayTeamMatchdata = matchStats.get(awayTeam.team_id) || {}

  const dataMissing =
    Object.keys(homeTeamMatchdata).filter((key) => homeTeamMatchdata[key] > 0)
      .length === 0 ||
    Object.keys(awayTeamMatchdata).filter((key) => awayTeamMatchdata[key] > 0)
      .length === 0

  return (
    <div className="matchDetailsContainer">
      {dataMissing && <DataMissing />}
      <DoubleBar
        homeCount={
          possessionInfo.get(homeTeam.team_id) ||
          100 - possessionInfo.get(awayTeam.team_id)
        }
        homeColour={homeTeam.team_first_color}
        awayCount={
          possessionInfo.get(awayTeam.team_id) ||
          100 - possessionInfo.get(homeTeam.team_id)
        }
        awayColour={awayTeam.team_first_color}
        title="Possession"
        units="%"
        total={100}
      />
      {matchStatFieldNames(
        Object.keys(homeTeamMatchdata).length > 0
          ? homeTeamMatchdata
          : awayTeamMatchdata
      ).map((statName) => {
        const homeCount = homeTeamMatchdata[statName] || 0
        const awayCount = awayTeamMatchdata[statName] || 0
        return (
          <DoubleBar
            key={statName}
            homeCount={homeTeamMatchdata[statName] || 0}
            homeColour={homeTeam.team_first_color}
            awayCount={awayCount}
            awayColour={awayTeam.team_first_color}
            title={snakeToPascal(statName)}
            units=""
            total={homeCount + awayCount}
          />
        )
      })}
    </div>
  )
}

export default MatchDetailsContainer
